import React from "react";
export const Plus = ({
  className,
  onClick,
}: {
  className?: string;
  onClick?: () => void;
}) => (
  <svg
    onClick={onClick}
    width={24}
    height={23}
    viewBox="0 0 24 23"
    className={className}
  >
    <defs>
      <style>{"\n      .a{fill:#70829b;}.b{fill:#fff;}\n    "}</style>
    </defs>
    <g transform="translate(0.216 -0.448)">
      <rect
        className="a"
        width={24}
        height={23}
        rx={11.5}
        transform="translate(-0.216 0.448)"
      />
      <g transform="translate(6.171 6.171)">
        <path
          className="b"
          d="M818.13,512.178v.19q0,1.452,0,2.9a.829.829,0,0,1-.892.885q-.951,0-1.9,0a.825.825,0,0,1-.867-.866q0-1.459,0-2.919v-.194h-3.083a.83.83,0,0,1-.9-.9q0-.937,0-1.873a.828.828,0,0,1,.885-.892q1.452,0,2.9,0h.19v-.183q0-1.459,0-2.919a.827.827,0,0,1,.885-.878h1.9a.826.826,0,0,1,.874.874q0,1.46,0,2.919v.186h.186q1.452,0,2.9,0a.829.829,0,0,1,.889.888q0,.929,0,1.859a.833.833,0,0,1-.907.914H818.13Z"
          transform="translate(-810.488 -504.535)"
        />
      </g>
    </g>
  </svg>
);
